import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { Chip } from '../Chip';
import type { ITagInputProps } from './ITagInputProps';
import { PickerList } from './PickerList';
import { useTagInput } from './useTagInput';
import './pickers.css';

/**
 * Поле тегів (UIUX/controls/tag-input; прототип v4): чипи 26px із крапкою й ×, поле введення без рамки (мін. 160px) усередині
 * рамки поля (клік по рамці ставить курсор у введення); підказки — до 8 тегів (спершу збіги з початку), «+ Створити «x»»
 * акцентом; підвал «Enter або кома — додати · ⌫ — видалити останній» і «Керування». Лише читання — чипи без ×, «Без тегів».
 */
export function TagInput(props: ITagInputProps) {
  const { t } = useTranslation();
  const s = useTagInput(props);
  const { chips, readOnly, variant = 'field' } = props;
  return (
    <div className={cx('tg', `tg--${variant}`, readOnly && 'is-ro')}
      onMouseDown={(e) => { if (!readOnly && e.target === e.currentTarget) { e.preventDefault(); s.input.current?.focus(); } }}>
      {!chips.length && (readOnly || props.showEmpty) && <span className="tg__empty">{props.emptyText}</span>}
      {chips.map((c) => (
        <Chip key={c.key} color={c.color ?? 'var(--line2)'} className="chip--tag" title={c.label} onRemove={readOnly ? undefined : () => props.onRemove(c.key)}>{c.label}</Chip>
      ))}
      {!readOnly && (
        <input ref={s.input} id={props.id} className="tg__input" role="combobox" aria-label={props.label} aria-expanded={s.open}
          aria-controls={s.open ? s.listId : undefined} aria-autocomplete="list" aria-activedescendant={s.open ? `${s.listId}-o${s.hi}` : undefined}
          autoComplete="off" spellCheck={false} value={s.query} placeholder={chips.length ? props.placeholderMore : props.placeholder}
          onFocus={s.show} onChange={(e) => s.change(e.target.value)} onKeyDown={s.onKeyDown} onBlur={s.onBlur} />
      )}
      {s.open && s.pos && (
        <PickerList listId={s.listId} panelRef={s.panel} pos={s.pos} label={props.label} options={s.options} value="" hi={s.hi}
          onPick={s.commit} onHover={s.setHi} search={null} emptyText="" className="pk-list--tags"
          footer={<><span className="pk-list__hint">{t('fieldControls.tagHint')}</span>{props.manage}</>} />
      )}
    </div>
  );
}
